import { dataImages } from "@/data/aboutUs";
import { Globe, Sparkles } from "lucide-react";

export default function UniqueValue() {
  return (
    <>
      <div className="flex flex-col bg-[#FFF8F6] px-40 py-10 gap-20">
        <div className="flex flex-col text-center gap-2" data-aos="fade-up">
          <h1 className="font-bold text-4xl">
            The <span className="text-[#B70100]">Fluenesia</span> Difference
          </h1>
          <p>
            Why learners choose us over conventional language-learning apps.
          </p>
        </div>
        <div className="grid grid-flow-col gap-4">
          <div
            className="row-span-3 col-span-2 bg-[#FFF0EE] rounded-2xl p-6"
            data-aos="fade-right"
          >
            <div className="flex flex-col h-full">
              <div className="flex flex-col mb-6">
                <h2 className="font-bold text-xl">Elite Tutor Network</h2>
                <p>
                  Unlike peer-to-peer platforms, Fluenesia admits only the top
                  3% of applicants. Every tutor holds an advanced degree and
                  brings 5+ years of professional teaching experience.
                </p>
              </div>

              <div className="flex w-full mt-auto gap-4">
                {dataImages.map((item, i) => (
                  <div key={i} className="flex justify-center mb-auto w-full">
                    <img
                      src={item.src}
                      alt={item.alt}
                      className="rounded-xl object-cover w-full"
                    />
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div
            className="col-span-1 bg-[#B70100] text-white rounded-2xl p-6"
            data-aos="fade-down"
          >
            <Sparkles />
            <div className="flex flex-col mt-4">
              <h2 className="font-bold text-xl">Curriculum Intelligence</h2>
              <p>
                We use technology to personalize each learner's experience,
                adapting lessons to their goals, proficiency, and pace while
                keeping the learning process purposeful and engaging.
              </p>
            </div>
          </div>
          <div
            className="col-span-1 row-span-2 bg-[#FFDAD4] rounded-2xl p-6"
            data-aos="fade-up"
          >
            <Globe className="text-[#B70100]" />
            <div className="flex flex-col mt-4">
              <h2 className="font-bold text-xl">Cultural Immersion</h2>
              <p>
                We don’t merely teach vocabulary, we cultivate an understanding
                of “Rasa,” the underlying soul of Indonesian culture, through
                immersive, real-world scenarios.
              </p>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
